import $ from "jquery";
import Marionette from "backbone.marionette";
import moment from "moment-timezone";
import _padStart from "lodash/padStart";
import _range from "lodash/range";

import { REMINDER_TYPE } from "lib/constants";

import appRemindTemplate from "../../templates/steps/application-reminder-modal.jst";
import resumeTemplate from "../../templates/steps/resume-reminder-modal.jst";

function submitReminder(reminderType, momentReminder) {
    return $.ajax({
        url: `/api/v1/reminder/${reminderType}/`,
        data: JSON.stringify({
            reminder_time: momentReminder.toISOString(),
        }),
        type: "POST",
        dataType: "json",
        contentType: "application/json",
    });
}

export const ApplicationReminderModal = Marionette.View.extend({
    template: appRemindTemplate,

    ui: {
        option: "button",
    },

    events: {
        "click @ui.option": "onSelect",
    },

    onSelect(event) {
        event.preventDefault();

        const $target = $(event.currentTarget);
        const remindType = $target.data("reminder");
        const now = moment();
        const remindTime = now.clone();

        if (remindType === "tonight") {
            const hour = now.hour();
            if (hour >= 18) {
                remindTime.add(1, "hour");
            } else {
                remindTime.hours(19);
            }
        } else if (remindType === "2hr") {
            remindTime.add(2, "hour");
        } else {
            remindTime.add(24, "hour");
        }

        submitReminder(REMINDER_TYPE.SAVE_APPLICATION, remindTime).done(() => {
            setTimeout(() => {
                window.location = "/";
            }, 0);
        });
    },

    onRender() {
        this.$el.modal({
            modalClass: "modal modal-small",
            closeClass: "icon-close",
            closeText: "",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
});

export const ResumeReminderModal = Marionette.View.extend({
    template: resumeTemplate,

    ui: {
        button: ".btn-primary",
        day: "[name=day]",
        time: "[name=time]",
    },

    events: {
        "change @ui.day": "onChangeDay",
        "click @ui.button": "onSubmit",
        "click .js-cancel": "onCancel",
        "click .js-skip": "onSkip",
    },

    serializeData() {
        const now = moment();
        const currentHour = now.hour();
        const today = now.startOf("day");

        // Default to 2 hours away, or if it's past 9pm
        // Default to 9am the next day
        const selectedDay = currentHour >= 21 ? 1 : 0;
        const selectedTime = currentHour < 9 || currentHour >= 21 ? 9 : currentHour + 3;

        const days = _range(0, 5).map((day) => {
            const date = today.clone().add(day, "days");
            let display = date.format("dddd");
            if (day === 0) {
                display = "Today";
            } else if (day === 1) {
                display = "Tomorrow";
            }

            return {
                value: date.format("YYYY-MM-DD"),
                display,
                selected: selectedDay === day,
            };
        });
        const times = _range(0, 24).map((hour) => {
            const ap = hour <= 11 ? "am" : "pm";
            const h = hour > 0 && hour <= 12 ? hour : Math.abs(12 - hour);
            const zHour = _padStart(hour, 2, "0");

            return {
                value: `${zHour}:00:00`,
                display: `${h}${ap}`,
                selected: selectedTime === hour,
            };
        });

        return {
            days,
            times,
        };
    },

    onRender() {
        this.$el.modal({
            modalClass: "modal modal-full",
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });

        this.onChangeDay();
    },

    onChangeDay() {
        const now = moment();
        const hour = now.hour();

        const selected = this.ui.day.val();
        if (selected === now.format("YYYY-MM-DD")) {
            this.ui.time.children().each((idx, el) => {
                if (idx <= hour) {
                    $(el).disable();
                } else if ((hour < 9 && idx === 9) || idx === hour + 2) {
                    el.selected = true;
                }
            });
        } else {
            this.ui.time.children().each((idx, el) => {
                $(el).enable();
            });
        }
    },

    onCancel(event) {
        event.preventDefault();

        $.modal.close();
        this.trigger("manual");
    },

    onSkip(event) {
        event.preventDefault();

        $.modal.close();
        this.trigger("skip");
    },

    onSubmit(event) {
        event.preventDefault();

        this.ui.button.loading(true);

        const day = this.ui.day.val();
        const time = this.ui.time.val();

        const momentReminder = moment(`${day} ${time}`, "YYYY-MM-DD HH:mm:ss");

        submitReminder(REMINDER_TYPE.UPLOAD_RESUME, momentReminder)
            .done(() => {
                this.trigger("success", momentReminder);
            })
            .always(() => {
                this.ui.button.loading(false);
            });
    },
});
